import StoreFilterService from '../../classes/StoreFilterService';

const storeFilterService = new StoreFilterService();

export const state = () => ({
	filterData: null,
	storesForFilter: null,
	filteredStores: null,
	filters: null,
	queryFilters: null,
});

export const getters = {
	filterData: state => state.filterData,
	storesForFilter: state => state.storesForFilter,
	filteredStores: state => state.filteredStores,
	filters: state => state.filters,
	queryFilters: state => state.queryFilters,
};

export const mutations = {
	SET_FILTER_DATA: (state, filterData) => {
		filterData.trademarks = filterData.trademarks.sort((a, b) => {
			if (a.title < b.title) return -1;
			if (a.title > b.title) return 1;
			return 0;
		})

		state.filterData = filterData;
	},
	SET_STORES: (state, storesForFilter) => {
		state.storesForFilter = storesForFilter;
	},
	SET_FILTERS: state => {
		const filters = {
			trademarks: [],
			cities: [],
		};

		state.filters = storeFilterService.getFiltersFromUrl(state.filterData, filters);
		state.queryFilters = storeFilterService.getQueryFilters(state.filters, state.filterData);
		state.filteredStores = storeFilterService.getFilteredStores(
			state.filters,
			state.storesForFilter,
		);
	},
	SET_FILTER: (state, { key, value }) => {
		state.filters[key] = value;
		state.queryFilters = storeFilterService.getQueryFilters(state.filters, state.filterData);
		state.filteredStores = storeFilterService.getFilteredStores(
			state.filters,
			state.storesForFilter,
		);
	},
};
